import React from "react";
import PropTypes from "prop-types";
import {RECEIPT_WORK_ORDER_FIELD_HEIGHT, RECEIPT_WORK_ORDER_FIELD_WIDTH} from "./styles/printDocumentStylesHomeDepot";

const PrintDocumentHeader = (props) => {
  const {View, Text, Image} = window.ReactPdfRenderer;

  const {styles, jobId, fabricatorData, printLogo, isContractSign, receiptWorkOrderNumber, messages,
    isHomeDepotReceipt} = props;

  const date = new Date();

  const logoView = printLogo ? (
    <View style={fabricatorData.isAmericanStandard ? [styles.headerLogo, styles.headerLogoAS] : styles.headerLogo}>
      <Image style={styles.headerLogoImage} source={{ uri: printLogo, method: "GET", headers: { "Cache-Control": "no-cache" } }} />
    </View>
  ) : null;

  // Extracted as its own row so the default (non-AS) receipt can render it full-width, above the narrow
  // headerTextASInfo column - a long WO# needs far more than that column's 20% of the page to fit on one
  // line, and widening the column itself would unbalance the (currently centered) logoView.
  const workOrderRow = isHomeDepotReceipt ? (
    <View style={styles.headerText}>
      <Text style={styles.headerTextBold}>WO #:</Text>
      <View receiptWorkOrderNumberField={true} style={{
        marginLeft: 1,
        // the fixed minWidth/height below are only needed as a fallback measured box for the /sign overlay
        // input (see RECEIPT_WORK_ORDER_FIELD_WIDTH/HEIGHT comment in styles/printDocumentStylesHomeDepot.js) -
        // the Text renders "" during isContractSign, so its box would otherwise collapse to ~0.
        // Do NOT apply a fixed height on the real receipt render: if a long WO# wraps to a 2nd line,
        // @react-pdf/textkit truncates with "…" whenever wrapped lines don't fit the box height,
        // unconditionally (independent of any textOverflow/maxLines style) - see typesetter() in
        // @react-pdf/textkit's lib/textkit.es.js.
        ...(isContractSign ? {
          minWidth: RECEIPT_WORK_ORDER_FIELD_WIDTH,
          height: RECEIPT_WORK_ORDER_FIELD_HEIGHT,
        } : null),
      }}>
        <Text style={[isContractSign
          ? [styles.headerTextValue, {textAlign: 'right', justifyContent: "flex-end"}]
          : styles.headerTextValue]}>
          {!isContractSign ? receiptWorkOrderNumber : ""}
        </Text>
      </View>
    </View>
  ) : null;

  const otherInfoRows = (
    <>
      {document.kvConfig.jobId || jobId ? (
        <View style={styles.headerText}>
          <Text style={styles.headerTextBold}>{messages["receipt.header.quoteNumber"]}</Text>
          <Text style={styles.headerTextValue}>{document.kvConfig.jobId || jobId}</Text>
        </View>
      ) : null}
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{messages["receipt.header.date"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleDateString().replace(/\//gi, "-")}</Text>
      </View>
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{messages["receipt.header.time"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleTimeString()}</Text>
      </View>
    </>
  )

  if (fabricatorData.isAmericanStandard) {
    return (
      <View style={styles.specSheet} fixed={true}>
        <View style={styles.headerTextASSheet}>
          <Text style={styles.headerTextBold}>Specification Sheet</Text>
        </View>
        {logoView}
        <View style={styles.headerTextASInfo}>
          <View style={styles.headerInfo}>
            {workOrderRow}
            {otherInfoRows}
          </View>
        </View>
      </View>
    )
  }

  return (
    <>
      {/* Rendered full-width, above the header row, so a long WO# has the whole page width to fit on one
          line - the headerTextASInfo column below is only 20% wide, nowhere near enough for a long value.
          headerText (its own style) is already width: 100% + justifyContent: flex-end, so it lines up with
          the same right edge as the quote#/date/time rows in the column below. */}
      {workOrderRow}
      <View style={styles.header}>
        <View style={styles.headerTextASSheet}/>
        {logoView}
        <View style={styles.headerTextASInfo}>
          <View style={styles.headerInfo}>{otherInfoRows}</View>
        </View>
      </View>
    </>
  )
};

PrintDocumentHeader.propTypes = {
  fabricatorData: PropTypes.object,
  jobId: PropTypes.number,
  styles: PropTypes.object.isRequired,
  printLogo: PropTypes.string,
  isContractSign: PropTypes.bool,
  receiptWorkOrderNumber: PropTypes.string,
  isHomeDepotReceipt: PropTypes.bool,
};

export default PrintDocumentHeader
